/**
 * PUT de HealthcareService do Pronto Atendimento.
 * Reutiliza auxiliarData.HealthcareService; id opcional = atualiza o único HCS.
 */
import * as uuid from "uuid";
import { endpoints } from "@/configs/Settings";
import { auxiliarData } from "@/services/fhir/AuxiliarData";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

export async function putProntoAtendimentoHealthcareService(
  objData: Record<string, unknown>,
  organizationId: string,
  /** Se informado, reutiliza o mesmo HCS (1 por agenda PA). */
  existingId?: string,
): Promise<{ id: string; name?: string }> {
  const id = existingId || uuid.v1();
  const url = `${endpoints.WORKFLOWFHIR}/HealthcareService/${id}`;
  const data = auxiliarData.HealthcareService(objData, organizationId, id);

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((res) => {
      if (
        res.status !== HTTPResponseStatus.Success &&
        res.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`putProntoAtendimentoHealthcareService: ${res.status}`);
      }
      return res.data as { id?: string; name?: string };
    })
    .catch((error) => {
      console.error("putProntoAtendimentoHealthcareService", error);
      throw error;
    });

  return {
    id: response?.id || id,
    name: response?.name || (objData.healthService as string),
  };
}
